import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Container, Row, Col, Card, Button, Form } from 'react-bootstrap';
import { Spinner } from 'react-bootstrap';

export default function ProductDetails({ handleCartClick, handleLikeClick , cartItems, likedItems, removeFromLiked , user, setUser, setCartItems, setLikedItems}) {
  const { productName } = useParams(); // URL: /product/:productName
  const [product, setProduct] = useState(null);
  const [review, setReview] = useState('');
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);


  const customerNames = [
    "Ravi S.", "Anjali K.", "Rahul T.", "Priya M.", "Neha P.", "Amit V.",
    "Suresh D.", "Kavita R.", "Pooja J.", "Vikram B.", "Divya N.", "Karan L.",
    "Sneha Z.", "Ajay M.", "Harsha Y.", "Pritam H.", "Meena Q.", "Alok F.",
    "Tanvi T.", "Nikhil G.", "Simran P.", "Aditya W.", "Gauri S.", "Jatin C.",
    "Rhea D.", "Mayank T.", "Rekha R.", "Sanjay U.", "Tanya V.", "Rohit B."
    // Add more if needed
  ];
  
  const customerComments = [
    "Great quality product!",
    "Delivered on time, no issues.",
    "Exactly as described. Happy with the purchase.",
    "Would definitely recommend to others.",
    "Product packaging was neat.",
    "A bit pricey but worth it.",
    "Customer support was helpful.",
    "I’ve been using it for a week, no complaints.",
    "Met all my expectations.",
    "Better than what I found in local stores.",
    "Super useful and easy to use.",
    "Good value for money.",
    "Exceeded my expectations.",
    "Nice design and functionality.",
    "Just what I needed!",
    "Will buy again.",
    "Loved the quality!",
    "Much better than similar products online.",
    "Very satisfied with the experience.",
    "Totally worth it."
  ];

  
  useEffect(() => {
    if (!productName) return;

    axios.get(`https://backend-matihaat.onrender.com/product-details`, {
      params: { name: productName }
    })
    .then((res) => {
      if (res.data) {
        setProduct(res.data);
        if (res.data) {
          setProduct(res.data);
        
          // Generate random rating between 3.9 and 5
          const randomRating = (Math.random() * (5 - 3.9) + 3.9).toFixed(1);
          setRating(parseFloat(randomRating));
        }
        
      }
    })
    .catch((err) => {
      console.error("Failed to fetch product details:", err);
    });
   
  }, [productName]);


  const generateRandomReviews = (count = 100) => {
    const reviews = [];
    for (let i = 0; i < count; i++) {
      const name = customerNames[Math.floor(Math.random() * customerNames.length)];
      const comment = customerComments[Math.floor(Math.random() * customerComments.length)];
      const stars = "⭐".repeat(Math.floor(Math.random() * 2) + 4); // 4 to 5 stars
      reviews.push({ user: name, comment, stars });
    }
    return reviews;
  };
  
  const [genericReviews] = useState(() => {
    const allReviews = generateRandomReviews(100);
    // Shuffle the reviews and pick the first 5
    return allReviews.sort(() => 0.5 - Math.random()).slice(0, 5);
  });  


  const handleAddReview = () => {
    if (review.trim()) {
      setReviews(prev => [...prev, { user: user?.name || "Anonymous", comment: review }]);
      setReview('');
    }
  };

  if (!product) return <p className="text-center py-5">Loading product details...</p>;

  // Ensure that product prices exist before calculating the discount
  const discountPercentage = product.mrp && product.selling_price
    ? Math.ceil(((product.mrp - product.selling_price) / product.mrp) * 100)
    : 0;

  // Ensure the image URL is correct, and provide a fallback image
  const imageUrl = `/images1/${product.name}.jpg` || '/images1/default.jpg';

  // Function to replace newlines (\n, \r\n) with <br />
  const processDescription = (description) => {
      if (!description) return "";
      return description
        .replace(/\. /g, '.<br/>')       // break after full stops
        .replace(/([A-Z ]+:)/g, '<br/><strong>$1</strong><br/>'); // highlight headers like "COMPOSITION:"
};

  // Process the description from the backend
  const descriptionWithLineBreaks = processDescription(product.description);

  return (
    <Container className="py-5">
      <h2 className="mb-4" style={{color:"#246452"}}>{product.name}</h2>
      <Row>
      <Col md={6} className="position-relative">
          <div style={{ position: 'relative', display: 'inline-block' }}>
          <div className="image-container">
            {!imageLoaded && <Spinner animation="border" variant="secondary" />}
            <img
              src={imageUrl}
              onLoad={() => setImageLoaded(true)}
              className="product-image-zoom"
              alt={product.item_name}
            />
          </div>
            <div
              style={{
                position: 'absolute',
                top: '10px',
                left: '10px',
                backgroundColor: '#dc3545', // Bootstrap danger color
                color: 'white',
                padding: '5px 10px',
                borderRadius: '5px',
                fontWeight: 'bold',
                fontSize: '14px'
              }}
            >
              {discountPercentage}% OFF
            </div>
          </div>
        </Col>

        <Col md={6}>
          <div
            dangerouslySetInnerHTML={{
              __html: descriptionWithLineBreaks // Render the processed description with <br /> for newlines
            }}
          />
          <br/>
          <p className='product-mrp text-muted'><strong>MRP:</strong> <s>₹{product.mrp}</s></p>
          <p className='product-price fw-bold' style={{ fontSize:"140%"}}><strong>Price:</strong> ₹{product.selling_price}</p>
          <Button
            className="add-to-cart btn btn-primary"
            onClick={() => {
              const updatedProduct = {
                ...product,
                _id: product._id || product.id || product.name, // fallback if _id isn't present
                item_name: product.item_name || product.name,
                img: imageUrl,
                rate: '₹' + product.selling_price
              };

              handleCartClick(updatedProduct);
            }}
          >
            Add to Cart
          </Button>
        </Col>
      </Row>

      <hr className="my-5" />

      <h4>Customer Reviews</h4>
      <h2 className="mb-1" style={{color:"#246452"}}>{product.name}</h2>
        {rating && <p style={{ fontSize: "1.1rem", color: "#f4b400" }}>⭐ {rating} / 5</p>}
      <Form>
        <Form.Group controlId="reviewInput">
          <Form.Control 
            as="textarea" 
            rows={3} 
            placeholder="Write your review..." 
            value={review}
            onChange={e => setReview(e.target.value)}
          />
        </Form.Group>

        <Button className="mt-2" onClick={handleAddReview}>Submit Review</Button>
      </Form>

      <div className="mt-4">
        {reviews.map((rev, i) => (
          <Card key={i} className="mb-2 p-3">
            <strong>{rev.user}</strong>
            <p>{rev.comment}</p>
          </Card>
        ))}
        {genericReviews.map((rev, i) => (
          <Card key={`generic-${i}`} className="mb-2 p-3 bg-light">
            <strong>{rev.user}</strong>
            <div style={{ color: "#f4b400" }}>{rev.stars}</div>
            <p>{rev.comment}</p>
          </Card>
        ))}

      </div>
    </Container>
  );
}
